import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";
import 'bootstrap-icons/font/bootstrap-icons.css';
const PublicacionesUsuario = () => {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch de datos desde el endpoint
  useEffect(() => {
    const fetchPublicaciones = async () => {
      try {
        const response = await fetch(
            "https://oficinavirtual-solponiente.com/api/publicaciones/", {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        if (!response.ok) {
          throw new Error("Error al obtener las publicaciones");
        }
        const data = await response.json();
        setPublicaciones(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPublicaciones();
  }, []);

  return (
    <div className="p-4">
      <Header></Header>
      
      <h4 className="mt-4 mb-3"><i className="bi bi-megaphone text-primary"></i> Publicaciones Recientes</h4> 

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <p className="mt-3">Cargando publicaciones...</p>
        </div>
      ) : error ? (
        <p className="text-danger text-center">{error}</p>
      ) : publicaciones.length === 0 ? (
        <p className="text-center">No hay publicaciones disponibles.</p>
      ) : (
        <Row>
          {publicaciones.map((publicacion) => (
            <Col md={12} lg={12} key={publicacion.PublicacionID} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="text-primary">
                    {publicacion.Titulo}
                  </Card.Title>
                  <Card.Text className="text-muted">
                    Publicado el{" "}
                    {new Date(publicacion.FechaPublicacion).toLocaleDateString()}
                  </Card.Text>
                  <Card.Text>{publicacion.Texto}</Card.Text>
                </Card.Body>
                {publicacion.Visibilidad ? (
                  <Card.Footer className="text-success">
                    <small>Visible para todos</small>
                  </Card.Footer>
                ) : (
                  <Card.Footer className="text-warning">
                    <small>Visible solo para usuarios seleccionados</small>
                  </Card.Footer>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default PublicacionesUsuario;
